import Vue from 'vue';
export const alias29fe4faa05e144f890cc84c3cca9daf8 = Vue;
